import { FacetsViewModel, ProductListSort } from '@/types/api'

import { PLPPages } from '@/app/(plp)/types'

export const COLOR_WHITE_ID = '15'

export const SORT_TITLES: Record<ProductListSort, string> = {
    [ProductListSort.MostVisited]: 'پربازدیدترین',
    [ProductListSort.Cheapest]: 'ارزان‌ترین',
    [ProductListSort.MostExpensive]: 'گران‌ترین',
    [ProductListSort.Newest]: 'جدیدترین',
}

export const PRICE_SLIDER_STEP = 50000

export const STOCK_FACET_KEY = 'onlyInStock'

export const ACTIVE_FACET_COUNT = 'count'

export const EXCLUDED_FACETS_KEYS: Record<PLPPages, (keyof FacetsViewModel)[]> = {
    [PLPPages.Brands]: ['brandFacets'],
    [PLPPages.Categories]: ['categories'],
    [PLPPages.Search]: [],
    [PLPPages.Tags]: [],
    [PLPPages.Combination]: ['brandFacets'],
    [PLPPages.Facets]: [],
    [PLPPages.BrandCategoriesCombination]: ['brandFacets'],
}

export const MobileFacetDrawerName = 'mobile-facet'
